import React from 'react';
import { asField } from 'informed';
import classnames from 'classnames';

export default asField(
  ({
    fieldState,
    fieldApi,
    onChange,
    field,
    onBlur,
    height,
    label,
    helpBlock,
    numbers,
    col,
    styleAtividade,
    forwardedRef,
    required,
    noLabel,
    ...props
  }) => (
    <div
      style={{ color: '#453166' }}
      className={classnames('text-input-form-state form-group', col, {
        required,
        'has-error': fieldState.error
      })}
    >
      {!noLabel && (
        <div style={{ display: 'flex' }}>
          <label
            style={{
              color: '#333333',
              fontSize: '14px',
              fontWeight: '600',
              font: 'Quicksand',
              marginBottom: '3px'
            }}
            htmlFor={field}
            {...props}
          >
            {label}
          </label>
        </div>
      )}

      <input
        step="any"
        type="number"
        style={{
          borderRadius: '10px',
          border: '1px solid #DED8D8',
          fontFamily: 'Public Sans',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 400,
          background: '#F7F7F7',
          color: '#383838'
        }}
        className={classnames('form-control', {
          'has-error': fieldState.error
        })}
        value={fieldState.value || ''}
        onChange={(e) => {
          fieldApi.setValue(e.target.value);
          fieldApi.setError(null);
          if (onChange) {
            onChange(e.target.value);
          }
        }}
        onBlur={onBlur}
        {...props}
      />
      {helpBlock && <small className="form-text text-muted">{helpBlock}</small>}
      {fieldState.error && (
        <small className={fieldState.error ? 'text-danger' : null}>
          {fieldState.error}
        </small>
      )}
    </div>
  )
);
